/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="fa2481c4-a7f1-4df3-8d20-079497bed9b7" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="ebecbf02-1848-4d51-ade6-b669b694a819" x="0" y="0" width="24" height="24" maskUnits="userSpaceOnUse">
            <g id="bda41db4-6f6b-4cfc-b615-3060110125fd">
              <path id="aca938dd-f301-458a-869b-702684f2f2d7" d="M8,5.11a5.49,5.49,0,0,0-.81,4.73,9.28,9.28,0,0,0,1.13,2.53,6.48,6.48,0,0,1,1.13,3.51h-1l.86,4.58h1.15a2,2,0,0,0,3.93,0h1.19l.82-4.58h-1a6.55,6.55,0,0,1,1.12-3.51,9.31,9.31,0,0,0,1.14-2.53,5.46,5.46,0,0,0-.82-4.73A5.49,5.49,0,0,0,12.43,3,5.46,5.46,0,0,0,8,5.11ZM12.43,21a1,1,0,0,1-.88-.53h1.77a1,1,0,0,1-.89.53Zm2.32-1.53h-4.6l-.48-2.58h5.54ZM16,5.69a4.5,4.5,0,0,1,.66,3.9,8.83,8.83,0,0,1-1,2.28,7.34,7.34,0,0,0-1.26,4H12.87V10h-1v5.89H10.48a7.34,7.34,0,0,0-1.26-4,8.83,8.83,0,0,1-1-2.28,4.51,4.51,0,0,1,.66-3.9A4.46,4.46,0,0,1,12.43,4,4.44,4.44,0,0,1,16,5.69Z" fill="#fff" style={{ fillRule: 'evenodd' }}/>
            </g>
          </mask>
        </defs>
        <g id="f4d91de4-b2da-40a7-aba0-9d5ab0ab4cdc">
          <g id="f3820b68-3b93-4cdb-b695-953754263296">
            <g id="f71ae0da-54b9-4786-91ce-d6dc9cf42fd8">
              <path id="f8c4ecef-c001-4257-ad19-61fb1fc58eac" d="M8,5.11a5.49,5.49,0,0,0-.81,4.73,9.28,9.28,0,0,0,1.13,2.53,6.48,6.48,0,0,1,1.13,3.51h-1l.86,4.58h1.15a2,2,0,0,0,3.93,0h1.19l.82-4.58h-1a6.55,6.55,0,0,1,1.12-3.51,9.31,9.31,0,0,0,1.14-2.53,5.46,5.46,0,0,0-.82-4.73A5.49,5.49,0,0,0,12.43,3,5.46,5.46,0,0,0,8,5.11ZM12.43,21a1,1,0,0,1-.88-.53h1.77a1,1,0,0,1-.89.53Zm2.32-1.53h-4.6l-.48-2.58h5.54ZM16,5.69a4.5,4.5,0,0,1,.66,3.9,8.83,8.83,0,0,1-1,2.28,7.34,7.34,0,0,0-1.26,4H12.87V10h-1v5.89H10.48a7.34,7.34,0,0,0-1.26-4,8.83,8.83,0,0,1-1-2.28,4.51,4.51,0,0,1,.66-3.9A4.46,4.46,0,0,1,12.43,4,4.44,4.44,0,0,1,16,5.69Z" fill="#05273e" className="icon-fill"/>
            </g>
            <g style={{ mask: 'url(#ebecbf02-1848-4d51-ade6-b669b694a819)' }}>
              <g id="a2e23732-50af-42dd-a2b1-e61143e53e93">
                <rect id="f08d28f0-52f5-4a14-9315-0eeb80410f25" width="24" height="24" fill="#002b49" className="icon-fill"/>
              </g>
            </g>
            <g style={{ mask: 'url(#ebecbf02-1848-4d51-ade6-b669b694a819)' }}>
              <rect id="a0b13420-4314-4723-8ab7-34d0acb17cb9" width="24" height="24" className="icon-fill"/>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'LightbulbIcon';

export default Icon;
